// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for the occupation / job ad rows live in DepartmentDropdown.css
   (shared "ja-" classes), so the whole Job Ads list is styled in one place. */
`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/LeftCard/OccupationDropdown.css"],"names":[],"mappings":"AAAA;8EAC8E","sourcesContent":["/* Styles for the occupation / job ad rows live in DepartmentDropdown.css\n   (shared \"ja-\" classes), so the whole Job Ads list is styled in one place. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
